<template>
  <div class="wrapper clickable" @click="displayMedia(true)">
    <div class="icon">
      <i class="fas fa-volume-up fa-3x"></i>
      <p class="title">{{ audioName }}</p>
    </div>

    <b-modal v-model="showModal"
             :title="audioName"
             centered 
             hide-footer
             size="md"
             no-close-on-backdrop>
      <div class="audio-container">
        <audio id="modalAudio" ref="modalAudio" controls="true">
          <source :src="url" />
        </audio>
      </div>
    </b-modal>

  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showModal: false
    }
  },
  computed: {
    url () {
      if (this.item.media[0]) {
        return this.item.media[0].url
      }
      return ''
    },
    audioName () {
      if (this.item.media[0]) {
        return this.item.media[0].name
      } else {
        return ''
      }
    },
    modalAudio () {
      return this.$refs.modalAudio
    }
  },
  watch: {
    showModal: function (val) {
      if (!val) {
        this.modalAudio.pause()
        this.modalAudio.currentTime = 0
      }
    }
  },
  methods: {
    displayMedia (show) {
      this.showModal = show
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'assets/stylesheets/main.scss';

.wrapper {
  height: 8rem;
  width: 15rem;
  position: relative;
  border-style: solid;
  border-width: 1px;
  border-radius: 5px;
  color: $medium-grey;
  overflow: hidden;
  margin-right: $spacing-sm;
  flex: 0 0 auto;
}

.cover {
  object-fit: cover;
  width: 15rem;
  height: 8rem;
}

.icon {
  position: absolute;
  text-align: center;
  top: 50%;
  left: 50%;
  transform: translate( -50%, -50% );
  z-index: 500;
  color: $medium-grey;
}

.title {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/client/items/audio.vue